import React from "react";
const DomainPathContext = React.createContext({ path: "" });
export default DomainPathContext;
